<script>
  import BasePopupWrapper from '../../../../popups/BasePopupWrapper/BasePopupWrapper.vue'
  import { getSupportedNetworks } from '@/shared/utils/apple-pay'
  const APPLE_PAY_SCRIPT_ID = 'apple-pay-script'
  if (!window.logAppleButton) {
    window.logAppleButton = (info) => {
      const el = document.getElementById('logApple')
      el.insertAdjacentHTML('beforeend', `<li id="two">${info}</li>`)
    }
  }
  export default {
    name: 'QuoteApplePayButton',
    components: {
      BasePopupWrapper,
    },
    props: {
      totalPrice: {
        type: Number,
        default: 0,
      },
      showBtn: {
        type: Boolean,
        default: false,
      },
      quoteNumber: {
        type: [String, Number],
      },
      getTotalCallBack: {
        type: Function,
      },
      acceptance: {
        type: Boolean,
        default: true,
      },
      validateBeforePayment: {
        type: Function,
        default: () => Promise.resolve(true),
      },
      canStartPayment: {
        type: Function,
        default: () => true,
      },
    },
    emits: ['succeedPayment', 'start-pay', 'cancel'],
    data() {
      return {
        scriptLoaded: false,
        log: [],
        orderid: '',
        disable: false,
        errorPopup: false,
      }
    },
    computed: {
      totalPrice_() {
        return this.totalPrice
      },
      acceptance_() {
        return this.acceptance
      },
      showBtn_() {
        return this.showBtn
      },
    },
    created() {
      // if (window.ApplePaySession) {
      //   this.scriptLoaded = true
      //   return
      // }
      this.loadAppleScript().then(() => {
        this.scriptLoaded = true
      })
    },
    methods: {
      onSubmitApplePay(event) {
        this.$emit('start-pay')
        if (!this.acceptance_) return
        if (!this.canStartPayment()) {
          this.$emit('cancel')
          return
        }
        if (!window.ApplePaySession) {
          console.error('[ApplePay] ApplePaySession not available')
          return false
        }
        const session = this.createSession()
        if (!session) {
          console.error('[ApplePay] createSession returned null')
          return false
        }

        const validateBeforePayment = this.validateBeforePayment
        session.orderIdQic = ''

        // ---- merchant validation ----
        session.onvalidatemerchant = (event) => {
          console.log('[ApplePay] onvalidatemerchant fired', event.validationURL)

          validateBeforePayment()
            .then((isValid) => {
              console.log('[ApplePay] validateBeforePayment ->', isValid)
              if (!isValid) throw new Error('validateBeforePayment returned false')
              return fetch('/payap?action=getorderid')
            })
            .then((res) => {
              console.log('[ApplePay] getorderid status', res.status)
              if (!res.ok) throw new Error(`getorderid HTTP ${res.status}`)
              return res.json()
            })
            .then((res) => {
              console.log('[ApplePay] getorderid response', res)
              if (!res.orderid) throw new Error('No orderid in response')
              session.orderIdQic = res.orderid
              return fetch(
                `/payap?action=getmerchantsession&url=${encodeURIComponent(event.validationURL)}&quoteno=${this.quoteNumber}`
              )
            })
            .then((res) => {
              console.log('[ApplePay] getmerchantsession status', res.status)
              if (!res.ok) throw new Error(`getmerchantsession HTTP ${res.status}`)
              return res.text() // get text first to inspect
            })
            .then((text) => {
              console.log('[ApplePay] getmerchantsession raw body:', text)
              let merchantSession
              try {
                merchantSession = JSON.parse(text)
              } catch (e) {
                throw new Error('Merchant session is not valid JSON: ' + text.slice(0, 200))
              }
              // 🔴 CRITICAL: Apple expects the raw session object.
              // If your backend wraps it (e.g. { data: {...} } or { session: {...} }), unwrap here:
              // merchantSession = merchantSession.data || merchantSession.session || merchantSession
              console.log('[ApplePay] merchantSession keys:', Object.keys(merchantSession))
              try {
                session.completeMerchantValidation(merchantSession)
                console.log('[ApplePay] completeMerchantValidation called')
              } catch (e) {
                console.error('[ApplePay] completeMerchantValidation threw:', e)
                session.abort()
                this.showErrorPopup()
              }
            })
            .catch((err) => {
              console.error('[ApplePay] Validation chain failed:', err)
              session.abort() // tell Apple to dismiss the sheet
              this.showErrorPopup()
            })
        }

        // ---- payment method ----
        session.onpaymentmethodselected = (event) => {
          console.log('[ApplePay] onpaymentmethodselected', event)
          session.completePaymentMethodSelection({
            newTotal: { label: 'QIC Insurance', amount: String(this.totalPrice_), type: 'final' },
          })
        }

        // ---- payment authorized ----
        const succeedCallback = this.succeedPayment.bind(this)
        const showErrorPopup = this.showErrorPopup.bind(this)
        session.onpaymentauthorized = (event) => {
          console.log('[ApplePay] onpaymentauthorized')
          const formData = new FormData()
          formData.append('token', JSON.stringify(event.payment.token))
          formData.append('orderid', session.orderIdQic)

          fetch('/payap?action=paymenttoken', { method: 'POST', body: formData })
            .then((res) => {
              console.log('[ApplePay] paymenttoken status', res.status)
              return res.json()
            })
            .then((res) => {
              console.log('[ApplePay] paymenttoken response', res)
              const STATUS = window.ApplePaySession
              session.completePayment({
                status: res.success ? STATUS.STATUS_SUCCESS : STATUS.STATUS_FAILURE,
              })
              if (res.success) succeedCallback()
              else showErrorPopup()
            })
            .catch((err) => {
              console.error('[ApplePay] paymenttoken failed:', err)
              session.completePayment({ status: window.ApplePaySession.STATUS_FAILURE })
              showErrorPopup()
            })
        }

        // ---- 🔑 these were missing ----
        session.oncancel = (event) => {
          console.warn('[ApplePay] session cancelled', event)
          this.$emit('cancel')
        }

        session.onerror = (event) => {
          console.error('[ApplePay] session error', event)
        }

        console.log('[ApplePay] session.begin()')
        session.begin()
      },
      createSession() {
        const supportedNetworks = getSupportedNetworks()
        const request = {
          countryCode: 'QA',
          currencyCode: 'QAR',
          supportedNetworks,
          merchantCapabilities: ['supports3DS'],
          total: { label: 'QIC Insurance', amount: String(this.totalPrice), type: 'final' },
        }
        return new window.ApplePaySession(3, request)
      },
      loadAppleScript() {
        return new Promise((resolve, reject) => {
          const el = document.getElementById(APPLE_PAY_SCRIPT_ID)

          if (el) {
            return resolve()
          }

          const script = document.createElement('script')
          script.onload = () => {
            resolve()
          }
          script.async = true
          script.id = APPLE_PAY_SCRIPT_ID
          script.src = 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js'
          document.head.appendChild(script)
        })
      },
      succeedPayment() {
        this.$emit('succeedPayment')
      },
      showErrorPopup() {
        this.errorPopup = true
        this.$refs.popup.open()
      },
    },
  }
</script>

<template>
  <div v-if="scriptLoaded" class="apple-pay">
    <!--
    	<ul id="logApple">
    	</ul>
    -->
    <!-- <button @click="check">check</button> -->
    <apple-pay-button
      v-show="showBtn_"
      buttonstyle="black"
      type="pay"
      locale="en"
      @click="onSubmitApplePay"
    ></apple-pay-button>
    <BasePopupWrapper v-if="errorPopup" ref="popup" @close="errorPopup = false">
      <div class="warning">
        <div class="titleWarn">
          {{ $t('qic_base_error_heder_line1') }} {{ $t('qic_base_error_heder_line2') }}
        </div>
        <!-- <div class="descWarn">{{ $te(message) ? $t(message) : message }}</div> -->
        <div class="descWarn">Please try another payment method</div>
      </div>
    </BasePopupWrapper>
  </div>
</template>

<style>
  apple-pay-button {
    --apple-pay-button-max-width: 416px;
    --apple-pay-button-width: 100%;
    --apple-pay-button-height: 80px;
    --apple-pay-button-border-radius: 12px;
    --apple-pay-button-padding: 15px 0px;
    --apple-pay-button-box-sizing: border-box;
  }
  .apple-pay-btn {
    --apple-pay-button-min-height: 80px;
  }
  .apple-pay {
    display: grid;
    direction: ltr !important;
  }
  .apple-pay-btn-wrapper .apple-pay-btn,
  .apple-pay-btn-wrapper {
    height: 80px;
    border-radius: 12px;
  }
  .apple-pay-btn-wrapper .apple-pay-btn > span > svg {
    height: 56px;
  }
</style>
